// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"802b5272","286":"4abb9587","309":"01de175e","391":"d75018c8","473":"0d3b4113","666":"086898ed","764":"e0d886cc","867":"f2c91dcf"}[chunkId] + ".chunk.js";
};